import { render, staticRenderFns } from "./DialogAddGroupReports.vue?vue&type=template&id=2c7acbf5"
import script from "./DialogAddGroupReports.vue?vue&type=script&lang=js"
export * from "./DialogAddGroupReports.vue?vue&type=script&lang=js"
import style0 from "./DialogAddGroupReports.vue?vue&type=style&index=0&id=2c7acbf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports